module.exports = __webpack_public_path__ + "static/media/Larken Bold.7d3e4112.ttf";